import http from "../../utils/http";
import {marsToBaidu} from "../../utils";
import * as TYPES from './action-types.js';
import channelMgr from "../../service/channel.js";
import { getHubStops, getReactiveLineStops, checkIsHubArea, checkIsBookingTicket, getRunTime, getPreTimeList } from './util.js'
import { ON_KEY_CALL, SUPPORT_HUB_MODE, SUPPORT_INNEAR_MODE } from "../../const/area";
import { ls } from "@/store/local-store";
import { VOICE_CODE } from "../../const/config.js";

export function HomeService(context) {
	let dispatch = context.$store.dispatch;
	const HOME__SET_AREA_ID_ACTION = `home/${TYPES.HOME__SET_AREA_ID}`;
	const HOME__SET_AREA_PICKER_VISIBLE = `home/${TYPES.HOME__SET_AREA_PICKER_VISIBLE}`;
	return {
		turnToHomeView(params) {
			context.$router.push({
				name: 'Home',
				params
			});
		},
		redirectToHomeView(params, query) {
			context.$router.replace({
				name: 'Home',
				params,
				query
			});
		},
		fetchAreas(params) {
			const linePromotionId = channelMgr.getChannelInfo('linePromotionId')
			return http.post('/order/getBaseLine', {
				...params,
				...( linePromotionId ? { promotionId: linePromotionId } : {})
			}).then((data) => {
				return (data || []).filter(p => !!p).map(item => {
					let {id: pid, route = '', smallRoute= '', reactiveLineStops = [], lng, lat, price, specialPrice, reactiveLineSectionTickets = [], discountFlag, lineName: name, publishValue,redirectUrl, runExplain, validTime, groupPrice, userNum, priceMode, distancePriceList,
						mode, parentId, direction, ticketType, preValidTime, reverseId, onStops, offStops, minUserNum
					} = item || {};
					// id：区域ID
					// area：区域列表
					// stops：站点列表
					// lng: 中心点经度
					// lat: 中心点纬度
					// price: 原价
					// specialPrice: 优惠价
					// reactiveLineSectionTickets: 阶梯价
					// startRunTime：开始运营时间
					// endRunTime：结束运营时间
					// name: 区域名
					let centerLng = lng;
					let centerLat = lat;
					if (lng && lat) {
						const {lng: _lng, lat: _lat} = marsToBaidu(lng, lat);
						centerLng = _lng;
						centerLat = _lat;
					}
					const isHubArea = checkIsHubArea(mode) // 是否枢纽站模式
					const isBookingTicket = checkIsBookingTicket(ticketType) // 是否预约单
					const isReversedExist = !!reverseId // 是否存在反向子区域
					const hubStops = getHubStops(direction, onStops, offStops) // 枢纽站点(此次需求只允许设置一个枢纽站)
					const preTimeList = getPreTimeList(ticketType, preValidTime)
					const { startRunTime, endRunTime, timeRangeList } = getRunTime(validTime)
					return {
						id: pid,
						area: Array.from(JSON.parse(route)).filter(p => !!p).map(point => {
							const {lng, lat} = marsToBaidu(...point);
							return [lng, lat];
						}),
						smallArea: smallRoute ? Array.from(JSON.parse(smallRoute)).filter(p => !!p).map(point => {
							const {lng, lat} = marsToBaidu(...point);
							return [lng, lat];
						}): [],
            publishValue, // 公告
            redirectUrl, // 公告跳转链接
						stops: getReactiveLineStops({ pid, mode, reactiveLineStops, direction, onStops, offStops }),
						lng: centerLng,
						lat: centerLat,
						price,
						specialPrice,
						priceList: reactiveLineSectionTickets.map(o => {
							let {orderNum: level, price, singalNum: num} = o || {};
							return {
								level,
								price,
								num
							};
						}),
						discountFlag,
						startRunTime,
						endRunTime,
						name,
            runExplain,
            timeRangeList,
            groupPrice,
            userNum,
						priceMode,
						distancePriceList,
						minUserNum,
						hubAreaInfo: {
							mode,
							parentId,
							direction,
							ticketType,
							preValidTime,
							reverseId,
							onStops,
							offStops
						}, // 枢纽站模式相关原始参数
						isHubArea,
						isBookingTicket,
						isReversedExist,
						hubStops,
						preTimeList
					};
				});
			});
		},
		setAreaId(areaId) {
			dispatch(HOME__SET_AREA_ID_ACTION, areaId);
		},
		getAreaId() {
			return context.$store.state.home.areaId;
		},
		setAreaPickerVisible(visible = true) {
			dispatch(HOME__SET_AREA_PICKER_VISIBLE, visible);
		},
    fetchConfig(params) {
			const cityId = params.cityId || ls.getItem('cityId');
      return http.get(`/index/config?cityId=${cityId}`, {}).then((res) => {
        const {title, guideState, guideUrl, buyTitle, buyContext, loginTitle, loginLogoUrl, clientContext, privacyContext} = res || {}
				const data = {
          pageTitle: title,
          isShowGuide: guideState === 1,
          guideLink: guideUrl,
          protocolTitle: buyTitle,
          protocolContent: buyContext,
					loginTitle,
					loginLogoUrl,
					clientContext,
					privacyContext,
        }
        dispatch('config/setTicketConfig', data)
				return data
      })
    },
		fetchCityConfig(params = {}) {
			const cityId = params.cityId || ls.getItem('cityId');
      return http.get(`/cityParamConfig?cityId=${cityId}`, {}).then((res) => {
        const { modeAreaInternal , modePointToArea, oneKeyCall, switchVoiceCode } = res || {}
        dispatch('config/setCityConfig', {
					modeAreaInternal: typeof modeAreaInternal === 'number' ? modeAreaInternal : SUPPORT_INNEAR_MODE.YES,
					modePointToArea: typeof modePointToArea === 'number' ? modePointToArea : SUPPORT_HUB_MODE.NO,
					oneKeyCall: typeof oneKeyCall === 'number' ? oneKeyCall : ON_KEY_CALL.ENABLE,
					voiceCode: typeof switchVoiceCode === 'number' ? switchVoiceCode : VOICE_CODE.DISABLE
        })
      })
		},
    // 获取一键叫车
    fetchReactiveCall(params = {}) {
      return http({
        url: `/call/getReactiveCall`,
        params
      }).then(res => {
        dispatch('config/setCallInfo', res)
      })
    },
		// 获取价格-未使用优惠劵
		fetchPrice(params = {}) {
			const { baseLineId, onStopId, onStopName, offStopId, offStopName, ticketNum, userId, payType, group, couponId } = params || {}
      return http({
        url: `/order/getPrice`,
				method: 'post',
        data: {
					baseLineId,
					onStopId,
					onStopName,
					offStopId,
					offStopName,
					ridership: ticketNum,
					userId,
					payType,
					group,
					couponId
				}
      })
		}
	};
}

export function install(Vue, context) {
	Vue.prototype.$HomeService = HomeService(context);
}
